import { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik"
import Select from "react-select";
import { toast } from "react-toastify";
import { dictionaryCRUD } from "../../../../actions/dictionary"
import { kayaCRUD } from "../../../../actions/kaya"



export const Other = (props) => {

  const {data, back, next, step3, setStep3, step4, setStep4, schema, age, loading} = props

  const [generatingRegNo, setGeneratingRegNo] = useState(false)
  const [marit, setMarit] = useState([])
  const [economic, setEconomic] = useState([])
  const [literac, setLiterac] = useState([])
  const [education, setEducation] = useState([])
  const [health, setHealth] = useState([])
  const [disability, setDisability] = useState([])
  const [nutrition, setNutrition] = useState([])
  const [resident, setResident] = useState([])
  const [mosquito, setMosquito] = useState([])
  const [vacci, setVacci] = useState([])

  // Load dropdown options
  useEffect(() => {
    setTimeout(() => {
      dictionaryCRUD.loadDictionaryData(50, 0, '', 14).then((resp) => {
        setMarit(resp.data.results)
      }).finally(() => {})
      dictionaryCRUD.loadDictionaryData(50, 0, '', 15).then((resp) => {
        setEconomic(resp.data.results)
      }).finally(() => {})
      dictionaryCRUD.loadDictionaryData(50, 0, '', 16).then((resp) => {
        setLiterac(resp.data.results)
      }).finally(() => {})
      dictionaryCRUD.loadDictionaryData(50, 0, '', 17).then((resp) => {
        setEducation(resp.data.results)
      }).finally(() => {})
      dictionaryCRUD.loadDictionaryData(50, 0, '', 18).then((resp) => {
        setHealth(resp.data.results)
      }).finally(() => {})
      dictionaryCRUD.loadDictionaryData(50, 0, '', 19).then((resp) => {
        setDisability(resp.data.results)
      }).finally(() => {})
      dictionaryCRUD.loadDictionaryData(50, 0, '', 23).then((resp) => {
        setNutrition(resp.data.results)
      }).finally(() => {})
      dictionaryCRUD.loadDictionaryData(50, 0, '', 21).then((resp) => {
        setResident(resp.data.results)
      }).finally(() => {})
      dictionaryCRUD.loadDictionaryData(50, 0, '', 22).then((resp) => {
        setMosquito(resp.data.results)
      }).finally(() => {})
      dictionaryCRUD.loadDictionaryData(50, 0, '', 20).then((resp) => {
        setVacci(resp.data.results)
      }).finally(() => {})
    }, 500)
  }, [])

  // Helper function to find selected option from list
  const findSelectedOption = (list, value) => {
    if (!value || !list || list.length === 0) return null;
    const item = list.find(dt => dt.id === value || dt.id === parseInt(value));
    return item ? { value: item.id, label: item.dictionary_item_name_en } : null;
  };

  const handleSubmite = (values) => {
    next(values, true)
    setStep4(!step4)
  }

  const handlePrev = (values) => {
    back(values)
    setStep3(!step3)
  }

  return (
    <>
      <Formik
        initialValues={data}
        onSubmit={handleSubmite}
        validationSchema={schema}
        enableReinitialize={true}
      >
      {({setFieldValue, values}) => (
        <Form>
        <div className={step4 ? "tab-pane fade" : !step3 ? "tab-pane fade" : "tab-pane fade show active"}   id="step-relation-info" role="tabpanel" aria-labelledby="step-relation-tab">
        <div>
          <div className="row">
            <div className="col-md-4 col-sm-12">
              <div className="mb-3">
                <label htmlFor="marital_status" className="form-label">Marital Status <span className="text-danger">*</span></label>
                <Select
                  options={
                    marit?.map((dt) => (
                      {value : dt.id, label : dt.dictionary_item_name_en}
                    ))
                  }
                  value={findSelectedOption(marit, values.dictionary_marital_status)}
                  placeholder="Select marital status"
                  onChange={(e) => setFieldValue('dictionary_marital_status', e.value)}
                  isSearchable={true}
                  name='dictionary_marital_status'
                />
                <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                  <span role='alert' className='text-danger'><ErrorMessage name='dictionary_marital_status' /></span>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-12">
              <div className="mb-3">
                <label htmlFor="economic_activity" className="form-label">Economic Activity <span className="text-danger">*</span></label>
                <Select
                  options={
                    economic?.map((dt) => (
                      {value : dt.id, label : dt.dictionary_item_name_en}
                    ))
                  }
                  value={findSelectedOption(economic, values.dictionary_economic_activity)}
                  placeholder="Select economic activity"
                  onChange={(e) => setFieldValue('dictionary_economic_activity', e.value)}
                  isSearchable={true}
                  name='dictionary_economic_activity'
                />
                <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                  <span role='alert' className='text-danger'><ErrorMessage name='dictionary_economic_activity' /></span>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-12">
              <div className="mb-3">
                <label htmlFor="literacy_level" className="form-label">Literacy Level <span className="text-danger">*</span></label>
                <Select
                  options={
                    literac?.map((dt) => (
                      {value : dt.id, label : dt.dictionary_item_name_en}
                    ))
                  }
                  value={findSelectedOption(literac, values.dictionary_literacy_level)}
                  placeholder="Select literacy level"
                  onChange={(e) => setFieldValue('dictionary_literacy_level', e.value)}
                  isSearchable={true}
                  name='dictionary_literacy_level'
                />
                <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                  <span role='alert' className='text-danger'><ErrorMessage name='dictionary_literacy_level' /></span>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-12">
              <div className="mb-3">
                <label htmlFor="education_level" className="form-label">Education Level <span className="text-danger">*</span></label>
                <Select
                  options={
                    education?.map((dt) => (
                      {value : dt.id, label : dt.dictionary_item_name_en}
                    ))
                  }
                  value={findSelectedOption(education, values.dictionary_education_level)}
                  placeholder="Select education level"
                  onChange={(e) => setFieldValue('dictionary_education_level', e.value)}
                  isSearchable={true}
                  name='dictionary_education_level'
                />
                <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                  <span role='alert' className='text-danger'><ErrorMessage name='dictionary_education_level' /></span>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-12">
              <div className="mb-3">
                <label htmlFor="health_status" className="form-label">Health Status <span className="text-danger">*</span></label>
                <Select
                  options={
                    health?.map((dt) => (
                      {value : dt.id, label : dt.dictionary_item_name_en}
                    ))
                  }
                  value={findSelectedOption(health, values.dictionary_health_status)}
                  placeholder="Select health status"
                  onChange={(e) => setFieldValue('dictionary_health_status', e.value)}
                  isSearchable={true}
                  name='dictionary_health_status'
                />
                <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                  <span role='alert' className='text-danger'><ErrorMessage name='dictionary_health_status' /></span>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-12">
              <div className="mb-3">
                <label htmlFor="disability_status" className="form-label">Disability <span className="text-danger">*</span></label>
                <Select
                  options={
                    disability?.map((dt) => (
                      {value : dt.id, label : dt.dictionary_item_name_en}
                    ))
                  }
                  value={findSelectedOption(disability, values.dictionary_disability_status)}
                  placeholder="Select disability"
                  onChange={(e) => setFieldValue('dictionary_disability_status', e.value)}
                  isSearchable={true}
                  name='dictionary_disability_status'
                />
                <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                  <span role='alert' className='text-danger'><ErrorMessage name='dictionary_disability_status' /></span>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-12" style={{display: age<=5 ? '' : 'none'}}>
              <div className="mb-3">
                <label htmlFor="nutrition_status" className="form-label">Nutrition Status <span className="text-danger">*</span></label>
                <Select
                  options={
                    nutrition?.map((dt) => (
                      {value : dt.id, label : dt.dictionary_item_name_en}
                    ))
                  }
                  value={findSelectedOption(nutrition, values.dictionary_nutrition_status)}
                  placeholder="Select nutrition status"
                  onChange={(e) => setFieldValue('dictionary_nutrition_status', e.value)}
                  isSearchable={true}
                  name='dictionary_nutrition_status'
                />
                <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                  <span role='alert' className='text-danger'><ErrorMessage name='dictionary_nutrition_status' /></span>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-12" style={{display: age>=15 && age<=49 && values.dictionary_gender===2 ? '' : 'none'}}>
              <div className="mb-3">
                <label htmlFor="vaccination_info" className="form-label">Vaccination Information <span className="text-danger">*</span></label>
                <Select
                  options={
                    vacci?.map((dt) => (
                      {value : dt.id, label : dt.dictionary_item_name_en}
                    ))
                  }
                  value={findSelectedOption(vacci, values.dictionary_vaccination_info)}
                  placeholder="Select vaccination info"
                  onChange={(e) => setFieldValue('dictionary_vaccination_info', e.value)}
                  isSearchable={true}
                  name='dictionary_vaccination_info'
                />
                <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                  <span role='alert' className='text-danger'><ErrorMessage name='dictionary_vaccination_info' /></span>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-12">
              <div className="mb-3">
                <label htmlFor="mosquito_net_status" className="form-label">Mosquito Net Status <span className="text-danger">*</span></label>
                <Select
                  options={
                    mosquito?.map((dt) => (
                      {value : dt.id, label : dt.dictionary_item_name_en}
                    ))
                  }
                  value={findSelectedOption(mosquito, values.dictionary_mosquito_net_status)}
                  placeholder="Select mosquito net usage"
                  onChange={(e) => setFieldValue('dictionary_mosquito_net_status', e.value)}
                  isSearchable={true}
                  name='dictionary_mosquito_net_status'
                />
                <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                  <span role='alert' className='text-danger'><ErrorMessage name='dictionary_mosquito_net_status' /></span>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-12">
              <div className="mb-3">
                <label htmlFor="residential_status" className="form-label">Residential Status <span className="text-danger">*</span></label>
                <Select
                  options={
                    resident?.map((dt) => (
                      {value : dt.id, label : dt.dictionary_item_name_en}
                    ))
                  }
                  value={findSelectedOption(resident, values.dictionary_residential_status)}
                  placeholder="Select residential status"
                  onChange={(e) => {
                    setFieldValue('dictionary_residential_status', e.value);
                    // Generate registration number when residential status is selected
                    if (values.kaya_id && e.value && !values.reg_no) {
                      setGeneratingRegNo(true);
                      kayaCRUD.generateRegistrationNumber(values.kaya_id, e.value)
                        .then((resp) => {
                          setFieldValue('reg_no', resp.data.reg_no);
                          toast.success(`Registration number generated: ${resp.data.reg_no}`, { autoClose: 5000 });
                        })
                        .catch((error) => {
                          console.error('Failed to generate registration number:', error);
                          toast.warning('Could not auto-generate registration number. Please enter manually.', { autoClose: 5000 });
                        })
                        .finally(() => {
                          setGeneratingRegNo(false);
                        });
                    }
                  }}
                  isSearchable={true}
                  name='dictionary_residential_status'
                />
                {generatingRegNo && (
                  <small className="text-info">
                    <span className="spinner-border spinner-border-sm me-1"></span>
                    Generating registration number...
                  </small>
                )}
                <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                  <span role='alert' className='text-danger'><ErrorMessage name='dictionary_residential_status' /></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <div className="d-flex align-items-start gap-3 mt-4">
          <button type="button" className="btn btn-light btn-label previestab"  onClick={handlePrev}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back</button>
          <button type='submit' className="btn btn-success right ms-auto">
            {!loading && <span className='indicator-label'><i className="las la-save la-lg"></i>Save </span>}
            {loading && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
      </Form>
      )}
      </Formik>
    </>
  )

}
